import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { ModalType } from '../../pages/CockpitPage';
import { Button } from '../ui/Button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/Form';
import { Input } from '../ui/Input';
import { Dialog } from '../ui/Dialog';
import { scoreExportValidation } from './validation/scoreExportValidation';
import { useMutation } from '@tanstack/react-query';
import { AdminClient } from '../../services/AdminClient';
import { useContext, useState } from 'react';
import { UserContext } from '../../context/UserProvider';
import { toast } from 'react-toastify';

type ManagementReportDialogType = {
    open: boolean;
    setOpenModal: (modalType: ModalType | null) => void;
};
export const ManagementReportDialog = ({ open, setOpenModal }: ManagementReportDialogType) => {
    const user = useContext(UserContext);
    const [downloadLink, setDownloadLink] = useState<string | null>(null);
    const mutation = useMutation({
        mutationFn: (data: { quarter: string; year: string }) => {
            return AdminClient(user).getManagementReport(data.quarter, data.year);
        },
    });
    const form = useForm<z.infer<typeof scoreExportValidation>>({
        resolver: zodResolver(scoreExportValidation),
        defaultValues: {
            quarter: '',
            year: '',
        },
    });

    const handleFileDownload = (data: Blob) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        setDownloadLink(url);
    };

    const onSubmit = async ({ quarter, year }: { quarter: string; year: string }) => {
        setDownloadLink(null);

        const toastInstance = toast.loading(`Ophalen management rapportage Q${quarter} ${year}...`);

        mutation.mutate(
            { quarter, year },
            {
                onSuccess: (data) => {
                    handleFileDownload(data);

                    toast.done(toastInstance);
                    toast.success(`Ophalen succesvol voor kwartaal ${quarter} van ${year}`);
                },
            },
        );
    };

    return (
        <Dialog open={open} onClose={() => setOpenModal(null)}>
            <Dialog.Title>Management rapportage</Dialog.Title>

            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
                    <FormField
                        control={form.control}
                        name="quarter"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Kwartaal</FormLabel>
                                <FormControl>
                                    <Input placeholder="kwartaal(1-4)" {...field} type="number" value={field.value as any} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="year"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Jaar</FormLabel>
                                <FormControl>
                                    <Input placeholder="YYYY" {...field} type="number" value={field.value as any} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <div className="flex justify-end pt-6">
                        <Button loading={mutation.isPending}>Ophalen</Button>
                    </div>
                </form>
            </Form>

            {downloadLink && (
                <a className="flex text-primary hover:underline" href={downloadLink} download="export.csv">
                    Download csv
                </a>
            )}
        </Dialog>
    );
};
